import { Injectable } from '@angular/core'
import { JsonEntity, JsonResource, JsonResponse } from '@ftr/contracts/api/core'

export type EntityResponse<TEntity extends JsonEntity> = JsonResponse<JsonResource<TEntity>, TEntity>
export type ListResponse<TEntity extends JsonEntity> = JsonResponse<JsonResource<TEntity>[], TEntity>

@Injectable()
export class JsonResponseMapper {
  mapEntity<TEntity extends JsonEntity>(response: EntityResponse<TEntity>): TEntity {
    return Object.assign({}, { id: response.data!.id }, { ...response.data!.attributes })
  }

  mapList<TEntity extends JsonEntity>(response: ListResponse<TEntity>): TEntity[] {
    if (!response.data) {
      return []
    }

    return response.data!.map(resource => this.mapEntity({ data: resource })!)
  }
}
